// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import SignInView from "@/views/SignInView.vue";
import SignupView from "@/views/SignupView.vue";
import ClassBookingView from "@/views/ClassBookingView.vue";
import NotFoundView from "@/views/NotFoundView.vue";
import DashboardView from "@/views/DashboardView.vue";
import RecordsView from "@/views/RecordsView.vue";
import FreeTrialView from "@/views/FreeTrialView.vue";
import ForgotPasswordView from "@/views/ForgotPasswordView.vue";
import ResetPasswordView from "@/views/ResetPasswordView.vue";
import ProfileView from "@/views/ProfileView.vue";
import MainLayout from "@/components/MainLayout.vue";

import { getUser, getMeOnce, clearSession } from "@/lib/session";

const routes = [
  // 인증이 필요한 메인 레이아웃
  {
    path: "/",
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      { path: "", redirect: "/dashboard" },
      {
        path: "dashboard",
        name: "Dashboard",
        component: DashboardView,
      },
      {
        path: "booking",
        name: "ClassBooking",
        component: ClassBookingView,
      },
      {
        path: "profile",
        name: "Profile",
        component: ProfileView,
      },
      {
        path: "records",
        name: "Records",
        component: RecordsView,
      },
    ],
  },
  // 인증이 필요하지 않은 페이지들
  { path: "/signin", name: "SignIn", component: SignInView },
  { path: "/signup", name: "Signup", component: SignupView },
  { path: "/free-trial", name: "FreeTrial", component: FreeTrialView },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPasswordView,
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPasswordView,
  },
  { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFoundView },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});

router.beforeEach(async (to) => {
  // 1️⃣ 인증 필요한 페이지 체크
  if (to.meta?.requiresAuth) {
    const me = getUser() ?? (await getMeOnce());
    if (!me) {
      clearSession();
      return { path: "/signin", query: { redirect: to.fullPath } };
    }
    return true;
  }

  // 2️⃣ 로그인/회원가입 페이지는 로그인된 사용자 차단
  const authPages = ["/signin", "/signup"];
  if (authPages.includes(to.path)) {
    const me = getUser() ?? (await getMeOnce());
    if (me) {
      // 이미 로그인되어 있으면 메인으로
      return { path: "/dashboard" };
    }
  }

  // 3️⃣ 나머지는 그냥 통과 (비밀번호 재설정, 404 등)
  return true;
});

export default router;
